import Firebase from "firebase/app";
import "firebase/storage";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";

export default {
  install(Vue) {
    /**
     * Configure default firebase
     */
    let config = {
      apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
      authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
      databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
      projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGE_SENDER_ID,
      appId: process.env.VUE_APP_FIREBASE_APP_ID,
      measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
    };
    Firebase.initializeApp(config);

    Vue.prototype.$auth = Firebase.auth;
    Vue.prototype.$firestore = Firebase.firestore;
    Vue.prototype.$storage = Firebase.storage;
    Vue.prototype.$functions = Firebase.functions;
  }
};
